var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "el-form-browser",
      attrs: { model: _vm.form, rules: _vm.rules }
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "url" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入访问地址" },
            model: {
              value: _vm.form.url,
              callback: function($$v) {
                _vm.$set(_vm.form, "url", $$v)
              },
              expression: "form.url"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0440e148", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0440e148","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/browser.vue
// module id = null
// module chunks = 